import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Hymn} from "../../../hymn/hymn";
import {DecimalPipe, NgIf} from "@angular/common";
import {MatCard, MatCardAvatar, MatCardHeader, MatCardSubtitle, MatCardTitle} from "@angular/material/card";
import {LayoutService} from "../../../service/layout.service";
import {SidenavService} from "../../../service/sidenav.service";
import {SettingsService} from "../../../service/settings.service";
import {Router} from "@angular/router";
import {MatInputModule} from "@angular/material/input";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";

@Component({
  selector: 'app-hymn-list',
  standalone: true,
  imports: [
    DecimalPipe,
    MatCard,
    MatCardAvatar,
    MatCardHeader,
    MatCardSubtitle,
    MatCardTitle,
    NgIf,
    MatInputModule,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './hymn-list.component.html',
  styleUrl: './hymn-list.component.scss'
})
export class HymnListComponent {

  hymns: Hymn[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: Hymn[],
              private layoutService: LayoutService,
              private router: Router,
              private sidenavService: SidenavService,
              private settingsService: SettingsService,
              private dialogRef: MatDialogRef<HymnListComponent>) {
    this.hymns = data;
  }

  onHymnSelected(hymnNumber: number) {
    if(this.layoutService.singleView) {
      this.sidenavService.closeList();
    }
    this.router.navigate([`/${this.settingsService.getHymnViewMode()}/${hymnNumber}`]);
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }
}
